import { Box, Typography } from "@mui/material";
import copy from "copy-to-clipboard";
import { MouseEvent, useState } from "react";
import BaleIcon from "../../../media/images/icons/bale.png";
import RubikaIcon from "../../../media/images/icons/rubika.png";

const ICON_SIZE = 28;

const CHANNELS = [
  {
    name: "تلگرام",
    href: "https://t.me/karentarabarnet",
    color: "#229ED9",
    textColor: "#fff",
    icon: (
      <Box
        sx={{
          width: ICON_SIZE,
          height: ICON_SIZE,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <svg width={22} height={22} viewBox="0 0 24 24" fill="none">
          <path
            d="M21.05 3.58 3.68 10.27c-1.18.47-1.17 1.12-.22 1.41l4.45 1.39 10.3-6.5c.49-.3.93-.13.57.19l-8.33 7.53-.31 4.64c.45 0 .65-.2.9-.44l2.16-2.1 4.49 3.31c.83.46 1.42.22 1.63-.77l2.95-13.9c.3-1.21-.46-1.76-1.22-1.45Z"
            fill="currentColor"
          />
        </svg>
      </Box>
    ),
  },
  {
    name: "بله",
    href: "https://ble.ir/join/8ELJbyZqgv",
    color: "#E8F8F3",
    textColor: "#008F6F",
    icon: (
      <Box
        component="img"
        src={BaleIcon}
        alt=""
        sx={{
          width: ICON_SIZE,
          height: ICON_SIZE,
          display: "block",
          flexShrink: 0,
          objectFit: "contain",
        }}
      />
    ),
  },
  {
    name: "روبیکا",
    href: "https://rubika.ir/karen_tarabarnet",
    color: "#F3F3F3",
    textColor: "#222",
    icon: (
      <Box
        component="img"
        src={RubikaIcon}
        alt=""
        sx={{
          width: ICON_SIZE,
          height: ICON_SIZE,
          display: "block",
          flexShrink: 0,
          objectFit: "contain",
        }}
      />
    ),
  },
] as const;

export default function ChannelLinks() {
  const [copiedChannel, setCopiedChannel] = useState<string | null>(null);

  // The Android WebView loads every link in-app, and messenger links redirect to
  // tg:// / bale:// / rubika:// schemes it can't handle, so they must leave the WebView.
  const handleClick = (
    event: MouseEvent<HTMLAnchorElement>,
    channel: (typeof CHANNELS)[number]
  ) => {
    const native = window.Native;
    if (!native) return;

    event.preventDefault();
    if (typeof native.openUrl === "function") {
      native.openUrl(channel.href);
      return;
    }

    copy(channel.href);
    setCopiedChannel(channel.name);
  };

  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "8px",
        marginBottom: "72px",
        padding: "14px 12px",
        borderRadius: "12px",
        backgroundColor: "bgColor.white",
        boxShadow: "0px 2px 10px 2px rgba(0,0,0,0.08)",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "13px",
          color: "primary.main",
          marginBottom: "12px",
        }}
      >
        عضویت در کانال‌های اطلاع‌رسانی
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          flexWrap: "wrap",
        }}
      >
        {CHANNELS.map((channel) => (
          <Box
            key={channel.name}
            component="a"
            href={channel.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event: MouseEvent<HTMLAnchorElement>) =>
              handleClick(event, channel)
            }
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              minHeight: 44,
              padding: "6px 14px",
              borderRadius: "10px",
              backgroundColor: channel.color,
              color: channel.textColor,
              textDecoration: "none",
              border: "1px solid",
              borderColor:
                channel.name === "تلگرام" ? "transparent" : "rgba(0,0,0,0.08)",
              transition: "opacity 0.2s ease, transform 0.15s ease",
              "&:hover": {
                opacity: 0.92,
                transform: "translateY(-1px)",
              },
              "&:active": {
                transform: "translateY(0)",
              },
            }}
          >
            {channel.icon}
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 700,
                color: channel.textColor,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
              }}
            >
              {channel.name}
            </Typography>
          </Box>
        ))}
      </Box>

      {copiedChannel && (
        <Typography
          sx={{
            marginTop: "12px",
            padding: "8px 10px",
            borderRadius: "8px",
            backgroundColor: "success.main",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 600,
            textAlign: "center",
            lineHeight: 1.8,
          }}
        >
          لینک کانال {copiedChannel} کپی شد. برای عضویت، آن را در مرورگر یا
          اپلیکیشن {copiedChannel} باز کنید.
        </Typography>
      )}
    </Box>
  );
}
